import { clearSession } from './loginService';

export const handleLogout = () => {
	clearSession();
	sessionStorage.clear();

	const base = process.env.PUBLIC_URL || '';
	window.location.replace(`${base}/login`);
};
